// CacheKey db2d1277532aaea4a9cd49320392a11a
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  tr: {
    date: {
      abbr_month_names: [
        null,
        "Oca",
        "Şub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "Ağu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara"
      ],
      month_names: [
        null,
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık"
      ],
      order: [
        "day",
        "month",
        "year"
      ],
      day_names: [
        "Pazar",
        "Pazartesi",
        "Salı",
        "Çarşamba",
        "Perşembe",
        "Cuma",
        "Cumartesi"
      ],
      formats: {
        default: "%d.%m.%Y",
        long: "%d %B %Y",
        short: "%d %b"
      }
    },
    time: {
      am: "AM",
      pm: "PM"
    },
    time_zones: {
      est: "Doğu Saati",
      edt: "Doğu Saati",
      cst: "Merkez Saati",
      cdt: "Merkez Saati",
      mst: "Dağ Saati",
      mdt: "Dağ Saati",
      pst: "Pasifik Saati",
      pdt: "Pasifik Saati",
      hst: "Hawaii-Aleutian Saati",
      hdt: "Hawaii-Aleutian Saati",
      akst: "Alaska Saati",
      akdt: "Alaska Saati"
    }
  }
}

